import {propsType} from "./Avatye";

export default function NplaceQuiz(props: propsType) {
    return <>NplaceQuiz</>
}